import { http } from '~/src/services/requests';

function cbsSubscriptionsService() {
  return {
    getPaymentMethodUpdateUrl: async (orgFprint: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/payment-method-update-link/`,
          method: 'GET',
        },
        true,
      );
    },
    getPaymentMethodIframeUrl: async (orgFprint: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/payment-method-iframe-url/`,
          method: 'GET',
        },
        true,
      );
    },
    getResolveScaUrl: async (orgFprint: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/resolve-sca-link/`,
          method: 'GET',
        },
        true,
      );
    },
    getSubscriptionPreview: async (
      orgFprint: string,
      queryParams?: Record<string, string>,
    ) => {
      const queryString = queryParams
        ? '?' + new URLSearchParams(queryParams).toString()
        : '';
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/api/v1/org/${orgFprint}/subscriptions/preview/${queryString}`,
          method: 'GET',
        },
        true,
      );
    },
    getInvoice: async (orgFprint: string, cbs_invoice_id: number) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/invoices/${cbs_invoice_id}/`,
          method: 'GET',
        },
        true,
      );
    },
    getInvoices: async (orgFprint: string, page?: number) => {
      const queryParams = page ? `?page=${page}` : '';
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/invoices/${queryParams}`,
          method: 'GET',
        },
        true,
      );
    },
    getCreditNotes: async (orgFprint: string, page?: number) => {
      const queryParams = page ? `?page=${page}` : '';
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/credit_notes/${queryParams}`,
          method: 'GET',
        },
        true,
      );
    },
    getCreditNotesByInvoice: async (
      orgFprint: string,
      invoiceId: number,
      page?: number,
    ) => {
      const pageParam = page ? `&page=${page}` : '';
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/credit_notes/?invoice_id=${invoiceId}${pageParam}`,
          method: 'GET',
        },
        true,
      );
    },
    getSubscriptionDetailsFromCbs: async (orgFprint: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/api/v1/org/${orgFprint}/subscriptions/details/`,
          method: 'GET',
        },
        true,
      );
    },
    updateSubscription: async (
      orgFprint: string,
      updateData: Record<string, any>,
    ) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/api/v1/org/${orgFprint}/subscriptions/`,
          method: 'PUT',
          body: updateData,
          headers: {
            'Content-Type': 'application/json',
          },
        },
        true,
      );
    },
    cancelSubscription: async (orgFprint: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/api/v1/org/${orgFprint}/subscriptions/`,
          method: 'PUT',
          body: { cancellation: true },
          headers: {
            'Content-Type': 'application/json',
          },
        },
        true,
      );
    },
    getPlanUpgradeOptions: async (orgFprint: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/api/v1/org/${orgFprint}/subscriptions/plan-upgrades/`,
          method: 'GET',
        },
        true,
      );
    },
    getPlanUpgradePreview: async (orgFprint: string, planId: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/api/v1/org/${orgFprint}/subscriptions/plan-upgrades/${planId}/preview/`,
          method: 'GET',
        },
        true,
      );
    },
    confirmPlanUpgrade: async (orgFprint: string, planId: string) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/api/v1/org/${orgFprint}/subscriptions/plan-upgrades/${planId}/confirm/`,
          method: 'PUT',
        },
        true,
      );
    },
    getTaxIdentifierUrl: async (
      orgFprint: string,
      action: string = 'edit',
      theme: string = 'light',
    ) => {
      return http.innerSendAuthenticated(
        {
          relativePath: `/cbs_subscriptions/org/${orgFprint}/business-entities/?action=${action}&theme=${theme}`,
          method: 'GET',
        },
        true,
      );
    },
  };
}

export default cbsSubscriptionsService();
